import { LineConnectionStatusType } from "../interfaces/StudentInterface";
import { BillingPlan } from "./BillingPlan";
import { PaidService } from "./PaidService";
import { AnalyticsLectureAttendanceLecture } from "./SectionAnalytics";
// src/interfaces/StudentInterface と被る所があるが徐々にこちらに移行する
// 現状必要なフィールドだけ記述しているので、こちらも徐々に追加前提
export type StudentStatus =
  | "waiting"
  | "preinviting"
  | "inviting"
  | "active"
  | "inactive";

export type Student = {
  id: string;
  fullName: string;
  firstName: string;
  firstNameKana: string;
  lastName: string;
  lastNameKana: string;
  status: StudentStatus;
  jobHuman: string;
  billingPlan?: BillingPlan;
  paidServices?: PaidService[];
  canUseLearningManagement?: boolean;
  canUseAiQuestion?: boolean;
  lineConnectionStatus: LineConnectionStatusType;
};

export type ContentCourseStudent = {
  id: string;
  fullName: string;
  status: StudentStatus;
  statusHuman: string;
  jobHuman: string;
  sharedAt: string | null;
  url: string | null;
  deliveryStatus: "in_delivery" | "scheduled_delivery" | "stop_delivery";
};

export const stoppingDelivery = (student: ContentCourseStudent) =>
  student.deliveryStatus === "stop_delivery";

export const INACTIVATION_REASONS = [
  {
    type: "withdrawn",
    label: "生徒の所属がなくなったため（退塾・退学・転学）",
  },
  {
    type: "suspended",
    label: "生徒がお休みしているため（休塾・休学）",
  },
  {
    type: "graduated",
    label: "生徒が卒業するため",
  },
  {
    type: "course_decided",
    label: "生徒の進路が決定したため",
  },
  {
    type: "section_changed",
    label: "生徒の所属教室・コースが変更になるため",
  },
  {
    type: "inactive_student",
    label: "生徒が学習記録を入力しないため",
  },
  {
    type: "cannot_login",
    label: "携帯電話を機種変更した、ログインできなくなったため",
  },
  {
    type: "test_account",
    label: "テストアカウントとして登録したため",
  },
  {
    type: "incorrect_student",
    label: "生徒登録を誤ったため",
  },
  {
    type: "canceled_studyplus_for_school",
    label: "Studyplus for Schoolの法人契約を解約するため",
  },
  {
    type: "other",
    label: "その他",
  },
] as const;

export type InactivationReasonType =
  (typeof INACTIVATION_REASONS)[number]["type"];

// TODO: 講座別のアナリティクスと共有できるフィールドが多いので、あとでリファクタする
export type LectureAttendanceStudentAnalytics = {
  lecturePresenceCount: ReadonlyArray<number>;
  lectureTotalCount: ReadonlyArray<number>;
  totalScore: number;
  scores: ReadonlyArray<number>;
  rank: number;
} & Pick<Student, "fullName" | "jobHuman" | "id">;

export type LectureAttendanceStudentAnalyticsTable = Pick<
  AnalyticsLectureAttendanceLecture,
  "columns" | "term"
> & {
  students: ReadonlyArray<LectureAttendanceStudentAnalytics>;
};
